'use strict';

var locals_STATS_index = require('../STATS/index.js');

/**
 * Устанавливаем STATS.VK_ACCESS_TOKEN
 */
const setVkAccessToken = (value) => {
    locals_STATS_index.VK_ACCESS_TOKEN = value;
};

module.exports = setVkAccessToken;
